import { render } from "./SuchfeldSelection.vue?vue&type=template&id=1983cfac&scoped=true"
import script from "./SuchfeldSelection.vue?vue&type=script&lang=js"
export * from "./SuchfeldSelection.vue?vue&type=script&lang=js"

import "./SuchfeldSelection.vue?vue&type=style&index=0&id=1983cfac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1983cfac"]])

export default __exports__